import React from "react";
import { Text, View, FlatList } from "react-native";

export function renderObjectValues(obj: any, keysToIgnore: string[], t: any) {
  if (!obj || typeof obj !== "object") {
    return null;
  }

  const data = Object.keys(obj).filter((key) => {
    if (keysToIgnore.includes(key)) return false;
    if (obj[key] === null || obj[key] === undefined || obj[key] === "")
      return false;
    return true;
  });

  return (
    <FlatList
      data={data}
      className="w-full"
      keyExtractor={(item, index) => index.toString()}
      renderItem={({ item, index }) => {
        if (typeof obj[item] === "object") {
          const newKeysToIgnore = [
            ...keysToIgnore,
            "rail",
            "originatorType",
            "address",
            "institutionAddress",
          ];
          return renderObjectValues(obj[item], newKeysToIgnore, t);
        }
        return (
          <View
            key={index}
            className="flex-row max-w-120 w-full justify-between mt-1.5"
          >
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              className="text-sm font-thin"
            >
              {t(`home/home:details.${item}`)}:
            </Text>
            <Text numberOfLines={1} ellipsizeMode="middle" className="text-sm">
              {Array.isArray(obj[item]) ? obj[item].join(", ") : obj[item]}
            </Text>
          </View>
        );
      }}
    />
  );
}
